import ManualAcceptanceTable from './ManualAcceptanceTable';

export default ManualAcceptanceTable;
